const GET_AVAILABLE_TOKENS = 'GET_AVAILABLE_TOKENS' as const;

const tokensActionTypes = {
  GET_AVAILABLE_TOKENS,
};

export { tokensActionTypes };
